import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////
import {
	Button,
	Dialog,
	DialogClose,
	DialogContent,
	DialogFooter,
	// DialogOverlay,
} from '@/app/shared/components';

interface RewardCollectionProps {
	isOpen: boolean;
	onClose: React.Dispatch<React.SetStateAction<boolean>>;
	newDiamonds: number;
}

export const RewardCollection: React.FC<RewardCollectionProps> = ({
	isOpen,
	onClose,
	newDiamonds,
}: RewardCollectionProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Functions  
	**********************/
	const handleCloseDialog = () => {
		onClose(false);
	};

	/*********************
	// #region Template
	**********************/
	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			{/* <DialogOverlay/> */}
			<DialogContent
				className="border-none bg-transparent"
				overlayClassname="bg-black/95"
			>
				<div className="flex items-center space-x-2">
					<div className="grid flex-1 gap-2">
						<p className="text-xl text-center font-bold">
							{t('collections.congratulationsMessage', {
								amount: newDiamonds,
							})}
						</p>
						<img
							className="mx-auto my-6"
							src={process.env.VITE_DIAMOND_SHADOW_IMAGE}
							alt={t('collections.congratulationsMessage', {
								amount: newDiamonds,
							})}
						/>
					</div>
				</div>
				<DialogFooter className="sm:justify-start">
					<DialogClose asChild>
						<Button
							type="button"
							variant="primary"
							onClick={handleCloseDialog}
							className="py-6 w-full flex items-center gap-1 text-sm rounded-lg"
						>
							{t('general.goBack')}
						</Button>
					</DialogClose>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
